import React, { type ReactNode } from 'react';

import { useAuth } from '@client/hooks/useAuth';
import NotFoundPage from '@client/pages/errors/404.page';

type TProps = {
  children: ReactNode;
};

export const ProtectedRoute: React.FC<TProps> = ({ children }: TProps) => {
  const { user } = useAuth();
  return user ? children : <NotFoundPage />;
};
